import React from 'react';


const Badge = ({ 
    count = 0, 
    children, 
    offset = [0, 0], 
    size = 'default',
    color = 'red',
    maxCount = 99,
    dot = false,
    showZero = false
}) => {
    const shouldShow = count > 0 || showZero || dot;

    const getSizeClasses = () => {
        switch (size) {
            case 'small':
                return 'min-w-[16px] h-4 text-[10px] px-1';
            case 'large':
                return 'min-w-[24px] h-6 text-sm px-2';
            default:
                return 'min-w-[20px] h-5 text-xs px-1';
        }
    };

    const getColorClasses = () => {
        switch (color) {
            case 'blue':
                return 'bg-blue-500 text-white';
            case 'green':
                return 'bg-green-500 text-white';
            case 'yellow':
                return 'bg-yellow-500 text-white';
            case 'gray':
                return 'bg-gray-500 text-white';
            default:
                return 'bg-red-500 text-white';
        }
    };

    const getDotClasses = () => {
        switch (size) {
            case 'small':
                return 'w-2 h-2';
            case 'large':
                return 'w-4 h-4';
            default:
                return 'w-3 h-3';
        }
    };

    const displayCount = dot ? '' : (count > maxCount ? `${maxCount}+` : count);

    return (
        <div className="relative inline-block mt-3">
            {children}
            {shouldShow && (
                <span 
                    className={`absolute -top-2 -right-2 rounded-full flex items-center justify-center font-medium ${
                        dot 
                            ? `${getDotClasses()} ${getColorClasses()}` 
                            : `${getSizeClasses()} ${getColorClasses()}`
                    }`}
                    style={{
                        transform: `translate(${offset[0]}px, ${offset[1]}px)`
                    }}
                >
                    {displayCount}
                </span>
            )}
        </div>
    );
};

export default Badge;